import { Button, Tag, Typography, Space } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { actionColor, fmt } from "./tenantPackageHelpers";

const { Text } = Typography;

interface Props {
  history: any[];
  historyLoading: boolean;
  onRefresh: () => void;
}

export const PackageCostHistory: React.FC<Props> = ({
  history,
  historyLoading,
  onRefresh,
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <Text strong className="text-sm">
          Assignment & Cost History
        </Text>
        <Button
          size="small"
          icon={<ReloadOutlined />}
          onClick={() => onRefresh()}
          loading={historyLoading}
        >
          Refresh
        </Button>
      </div>

      {history.length === 0 ? (
        <div className="text-center text-gray-400 text-sm py-6">
          No history yet.
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {history.map((h: any) => (
            <div
              key={h.id}
              className="border border-gray-100 rounded-lg p-3 bg-white"
            >
              <div className="flex items-center justify-between mb-1">
                <Space size="small">
                  <Tag
                    color={actionColor[h.action] ?? "default"}
                    bordered={false}
                  >
                    {h.action}
                  </Tag>
                  <Text className="text-xs font-medium">{h.package_name}</Text>
                </Space>
                <Text strong className="text-sm">
                  {fmt(Number(h.total_amount) || 0)}
                </Text>
              </div>
              <div className="text-[11px] text-gray-500 flex gap-3">
                <span>Base {fmt(Number(h.amount) || 0)}</span>
                <span className="text-amber-600">
                  Add-ons {fmt(Number(h.additional_amount) || 0)}
                </span>
                <span>
                  {h.created_at
                    ? new Date(h.created_at).toLocaleString()
                    : ""}
                </span>
              </div>
              {h.note && (
                <div className="mt-1 text-[11px] italic text-gray-600 bg-gray-50 rounded px-2 py-1">
                  “{h.note}”
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
